import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { PORTAL_USER_TYPE } from "@/app/models";
import { ROUTES } from "@/app/router";
import {
  queriesStore,
  setEmbeddablesPassword,
} from "@/features/embeddables/api";
import { useEmbeddablesUser } from "@/features/embeddables/context";
import { EMBEDDABLES_ROUTE } from "@/features/embeddables/router";
import { authStore } from "@/shared/stores";
import { errorToast } from "@/shared/ui";

export const useSetEmbeddablesPassword = () => {
  const { type } = useEmbeddablesUser();
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  return useMutation({
    mutationFn: setEmbeddablesPassword,
    onError: errorToast,
    onSuccess: ({ accessToken }) => {
      authStore.setToken(accessToken);
      void queryClient.invalidateQueries({ queryKey: queriesStore.user._def });

      if (type === PORTAL_USER_TYPE.COACHING) {
        return navigate(EMBEDDABLES_ROUTE.SUCCESS, { state: type });
      }

      navigate(ROUTES.HOME);
    },
  });
};
